module.exports = __webpack_public_path__ + "img/pinterest.4115fa00.png";